//#region Libraries
//#endregion
//#region Styles
import { 
    Container,
    TDef } from "components/CustomTableList/components/TableListItem/ListItem/styles";
import { CustomActionsCell, CustomCell } from "./styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import TrashIcon from "icons/TrashIcon";
//#endregion
//#region Services
//#endregion
//#region Utils
//#endregion

const TableListItem = ({
    id, dayName,
    timeStart, timeEnd,
    deleteItem
}) => {
    const PROPS_CELL = {
        className: "small pair-row"
    };
    return (
        <Container>
            <TDef>
                <CustomCell {...PROPS_CELL}>
                    <h5 title={dayName}>{dayName}</h5>
                </CustomCell>
            </TDef>
            <TDef>
                <CustomCell {...PROPS_CELL}>
                    <h5 title={timeStart}>{timeStart}</h5>
                </CustomCell>
            </TDef>
            <TDef>
                <CustomCell {...PROPS_CELL}>
                    <h5 title={timeEnd}>{timeEnd}</h5>
                </CustomCell>
            </TDef>
            <TDef>
                <CustomActionsCell {...PROPS_CELL}>
                    <CustomButton 
                        variant="terciary"
                        color="dark"
                        icon={<TrashIcon/>}
                        onClick={() => deleteItem({ id, dayName })}/>
                </CustomActionsCell>
            </TDef>
        </Container>
    );
}

export default TableListItem;